import { Component, NgZone, OnInit, Sanitizer } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Campagne } from '@core/models/campagne.model';
import { GlobalDataService } from '@core/services';
import { CampagneService } from '@core/services/campagne.service';
import { Subscription } from 'rxjs';

import * as $ from 'jquery';



@Component({
  selector: 'app-campagne-validation-bat',
  templateUrl: './campagne-validation-bat.component.html',
  styleUrls: ['./campagne-validation-bat.component.scss']
})
export class CampagneValidationBatComponent implements OnInit {

  campagne?: Campagne;
  name = 'Angular 6';
  safeSrc: SafeResourceUrl;
  closing = false;
  batPageLoaded = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    public _GlobalDataService: GlobalDataService,

  ) {

    this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("/gtmt/gtmt_bat.cfm");

    console.log(this.safeSrc);

   }


  ngOnInit(): void {
  }

  uploadDone() {
    if (this.closing) return;

    console.log("uploadDone");
    var iframe: any = document.getElementById("iframe");
    var login = iframe.contentWindow.document.getElementById("coclico");
    var password = iframe.contentWindow.document.getElementById("pwd");
    var submit = iframe.contentWindow.document.getElementsByName("valider")[0];

    if (login) {
      login.value = this._GlobalDataService.Campagne.LoginBAT;
      console.log(login);
    }
    if (password) {
      password.value = this._GlobalDataService.Campagne.MotDePasseBAT;
      console.log(password);
    }
    if (login && password && submit) {
      submit.click();
      return;
    }

    // Chercher le bouton Fermer sur la page BAT
    var iframeDoc = iframe.contentWindow.document;
    var fermerTrouve = false;

    iframeDoc.querySelectorAll('input, button').forEach((btn: any) => {
      var label = (btn.value || btn.textContent || btn.innerText || '').trim().toLowerCase();
      if (label === 'fermer') {
        fermerTrouve = true;
        this.batPageLoaded = true;
        btn.onclick = (event: Event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.ngZone.run(() => this.fermer());
          return false;
        };
      }
    });

    // Si le bouton Fermer était présent avant mais ne l'est plus : l'utilisateur a cliqué Fermer
    if (!fermerTrouve && this.batPageLoaded) {
      this.ngZone.run(() => this.fermer());
    }
  }

  fermer() {
    this.closing = true;
    const path = this._GlobalDataService.isStandaloneContext() ? '/standalone/home' : '/campagne/home';
    const IdCampagne = this._GlobalDataService.Campagne.IdCampagne;
    const view = this._GlobalDataService.Campagne.FrequenceEnvoi === 'Récurrente'
      ? 'suivi-campagne-recurrente'
      : 'suivi-campagne-une-seule-fois';

    this.router.navigate([path, { outlets: { 'navview': [view, IdCampagne] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
  }

}